import { Card, Tooltip } from 'antd';
import { RightOutlined, SettingOutlined } from '@ant-design/icons';
import { useContext, useState } from 'react';
import './GoogleReviews.css';
import '../../pages.scss';
import ReviewsContainer from '../../../components/model/reviews/reviews/ReviewsContainer';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import { Synchronized } from '../../../components/design/Synchronized/Synchronized';
import { SCHEDULEDJOB } from '../../../../common/constants/services';
import { useIsAuthorized } from '../../common/roles/Roles';
import { RemovedReviewsModal } from './Reviews/modal/RemovedReviewsModal';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { PageTitle } from '../../common/PageTitle';

export const GoogleReviews = () => {

	const isAuthorized = useIsAuthorized();
	const { setConfigureIADrawer } = useContext(DrawerContext)
	const [openRemovedModal, setOpenRemovedModal] = useState(false);
	const { getGroupName } = useAuth();		
	
	const esTodosLosGrupos = getGroupName() === 'Todos los Grupos';
	const tienePermisos = isAuthorized(['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_CLIENT', 'ROLE_MODULE_REVIEWS']);

	return (
		<>
			<Card className='main-card-content'>

				<Synchronized service={[SCHEDULEDJOB.GBP_REVIEWS]} />

				<div>
					<PageTitle
						title='Responder Reseñas'
						pageInfo='Responde reseñas desde esta pantalla si lo que quieres es hacerlo desde una forma global para todo el grupo de locales. Responder reseñas será más rápido con las sugerencias de la IA, estas sugerencias se basan por defecto en la información de la propia ficha (nombre, descripción y categoría), pero desde la pantalla de Agente IA puedes añadir todo tipo de personalizaciones, además puedes automatizar las respuestas según la puntuación de la misma y si tienen o no texto.'
						extra={
							esTodosLosGrupos ? (
								<Tooltip
									color='transparent'
									overlayInnerStyle={{ padding: 0, boxShadow: 'none' }}
									title={
										<span style={{
											display: 'inline-block',
											padding: '10px 14px',
											borderRadius: 10,
											background: '#fffbeb',
											border: '1px solid #fcd34d',
											color: '#b45309',
											fontSize: 13,
											fontWeight: 500,
											lineHeight: 1.5,
											maxWidth: 280,
										}}>
											Debes seleccionar un grupo de Google en la cabecera, cada grupo tiene su propia configuración
										</span>
									}
								>
									<span>
										<ButtonLZ
											disabled
											type='dashed'
											style={{
												borderColor: 'slategrey',
												backgroundColor: 'ghostwhite',
												cursor: 'not-allowed',
												transition: 'all 0.3s',
											}}
										>
											<div style={{ color: 'slategrey', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 500 }}>
												<SettingOutlined />
												Responder con IA
											</div>
										</ButtonLZ>
									</span>
								</Tooltip>
							) : (
								<ButtonLZ
									disabled={!tienePermisos}
									type='default'
									onClick={() => { setConfigureIADrawer(true); }}
								>
									<div style={{ color: 'black', display: 'flex', alignItems: 'center', gap: '6px' }}>
										<SettingOutlined />
										Responder con IA
									</div>
								</ButtonLZ>
							)
						}
					/>
					<p style={{marginBottom:'0px'}}>Sin agrupar</p>
				</div>

				<ReviewsContainer
					abovePagination={
						<button
							type="button"
							onClick={() => { setOpenRemovedModal(true); }}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								gap: 8,
								padding: '6px 12px',
								margin: 0,
								border: '1px solid #e2e8f0',
								borderRadius: 8,
								background: '#f8fafc',
								boxShadow: 'none',
								cursor: 'pointer',
								textAlign: 'left',
								transition: 'border-color 0.15s, background 0.15s',
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.background = '#f1f5f9';
								e.currentTarget.style.borderColor = '#cbd5e1';
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.background = '#f8fafc';
								e.currentTarget.style.borderColor = '#e2e8f0';
							}}
						>
							<span style={{ fontSize: 13, fontWeight: 500, color: '#64748b' }}>
								Ver Reseñas Eliminadas
							</span>
							<RightOutlined style={{ fontSize: 11, color: '#94a3b8', flexShrink: 0 }} />
						</button>
					}
				/>
			</Card>			
			{openRemovedModal && <RemovedReviewsModal onFinish={() => {setOpenRemovedModal(false)}}/>}
		</>
	)
}
